import React, {Component} from 'react';
import classes from './Dept.css';
import Tile from '../Tile/Tile';

class Dept extends Component{
    state = {
        Departments : ['CSE','ECE','MECH','EEE','CE','MAT','PHIL','OTH']
    };
    clicked = (dept) => {
        this.props.clicked(dept);
        this.props.history.push('/subs')
    }
    render () {
        const Department = (
            this.state.Departments.map(department => {
                return ( <Tile type='Department' key={department} ele={department} clicked={this.clicked}/>
        )}));
        return (
            <div className = {classes.Department}>
                {Department}
            </div>
        )
    }
}

export default Dept;


// WEBPACK FOOTER //
// ./src/components/Contents/Lists/Dept/Dept.js